module.exports = __webpack_public_path__ + "static/img/er2.51eece2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/er2.png
// module id = 9EEg
// module chunks = 1